import React                         from 'react';
import {Route, IndexRoute, Redirect} from 'react-router';
import App                           from 'components/App';
import Login                         from 'components/login';
import OneTimePassword               from 'components/oneTimePassword';
import Register                      from 'components/register';
import PaymentDetails                from 'components/user/paymentDetails';
import SubmitItemForm                from 'components/submitItemForm';
import SubmitJewelryBoxForm          from 'components/submitJewelryBoxForm';
import Item                          from 'components/item';
import JewelryBoxChatBot             from "components/chatBot/jewelryBoxChatBot";
import NoMatch                       from 'components/noMatch';
import MyAccount                     from 'components/myAccount/myAccount';
import I18n                          from 'lib/i18n/i18n';
import Trends                        from 'components/trends/trends';
import MissingDetails                from 'components/user/missingDetails'
import SubmitItem                    from 'components/submit/SubmitItem'
import HowItWorks                    from 'components/howItWorks'
import SellingWithTrust              from 'components/sellingWithTrust'
import Experts                       from 'components/experts/expertsLayout'
import Listing                       from 'components/listing/listing'
import LightListing                  from 'components/lightListing/lightListing'
import HomePage                      from 'components/homepage/homepage'
import ListingTrends                 from 'components/trends/listingTrends'
import LightTrends                   from 'components/trends/lightTrends'
import ManageCallMain                from 'components/manageCall/manageCallMain'
import { sellerDashboardUrl, storeUvid } from './helpers/ApplicationHelper';
import cookie from 'react-cookie';


function onEnterItemsRoute(nextState, replace) {
    if (typeof window !== 'undefined') {
        const newURL = new URL(sellerDashboardUrl('/'));
        const uvid = cookie.load('uvid');
        if (uvid) {
            newURL.searchParams.set('uvid', uvid);
        }
        window.location.href = newURL.toString();
    }
}

function saveUvid(nextState, replace) {
  const params = new URLSearchParams(nextState.location.search);
  const uvid = params.get('uvid');
  if (uvid) {
    if (typeof window !== 'undefined') {
      storeUvid(uvid);
    }
  }
}


export default (
    <Route path="/" component={App} onEnter={saveUvid}>
            <IndexRoute component={SubmitItemForm} title={I18n.getString('titles::form')} />
            <Route path="/about/how-it-works" component={HowItWorks} title={I18n.getString('titles::howItWorks')} />
            <Route path="/about/selling-with-trust" component={SellingWithTrust} title={I18n.getString('titles::sellingWithTrust')}/>
            <Route path="/learn" component={Experts} title={I18n.getString('titles::experts')} metaData={I18n.getString('metaData::experts')}>
                <Route path="/learn/where-to-sell" title={I18n.getString('titles::whereToSell')} metaData={I18n.getString('metaData::whereToSell')}/>
                <Route path="/learn/how-to-price" title={I18n.getString('titles::howToPrice')} metaData={I18n.getString('metaData::howToPrice')}/>
                <Route path="/learn/calculator" title={I18n.getString('titles::calculator')} metaData={I18n.getString('metaData ::calculator')}/>
            </Route>
            <Route path="/submit/multiple_jewelry" component={SubmitJewelryBoxForm} title={I18n.getString('titles::form')} />
            <Route path="/submit/loose_diamond" component={SubmitItemForm} title={I18n.getString('titles::form')}/>
            <Route path="/submit/:itemType" component={SubmitItem} title={I18n.getString('titles::form')} />
            <Redirect path="/submit" to="/"/>
            <Route path="/homepage" component={HomePage} title={I18n.getString('titles::homePage')} />
            <Route path="/signin" component={Login} title={I18n.getString('titles::loginPage')} />
            <Route path="/signin/otp" component={OneTimePassword} title={I18n.getString('titles::loginPage')} />
            <Route path="/register" component={Register} title={I18n.getString('titles::registerPage')} />
            <Route path="/item/:itemId/survey" component={Item} title={I18n.getString('titles::itemPage')} />
            <Route path="/item/:itemId/skip_photo_upload" component={Item} title={I18n.getString('titles::itemPage')} />
            <Route path="/item/:itemId" component={Item} title={I18n.getString('titles::itemPage')} />
            <Route path="/item/:itemId/high_value" component={Item} title={I18n.getString('titles::itemPage')} />
            <Route path="/multiple_jewelry/:id" component={JewelryBoxChatBot} title={I18n.getString('titles::jewelryBoxPage')} />
            <Route path="/user/payment_details" component={PaymentDetails} title={I18n.getString('titles::paymentDetails')} />
            <Route path="/user/payment_details/item/:itemId" component={PaymentDetails} title={I18n.getString('titles::paymentDetails')} />
            <Route path="/item/:itemId/trends" component={Trends} title={I18n.getString('titles::trends')}/>
            <Route path="/items" title={I18n.getString('titles::myAccountPage')} component={MyAccount}  onEnter={onEnterItemsRoute}/>
            <Route path="/refer_a_friend" component={(props) => <Login showLinkToRegister={true} redirectTo='/refer_a_friend' />} title={I18n.getString('titles::loginPage')}/>
            <Route path="/items/:id" title={I18n.getString('titles::myAccountPage')} component={(props) =>
                <MyAccount selectedBundle={props.params.id}/>
            }/>
            <Route path={"/item/:itemId/missing-details"} component={MissingDetails} title={I18n.getString('titles::myAccountPage')} />
            <Route path={"/listing/:itemId"} component={Listing} title={I18n.getString('titles::listing')} />
            <Route path={"/ll/:itemId"} component={LightListing} title={I18n.getString('titles::listing')}  onEnter={onEnterItemsRoute} />
            <Route path="/listing/:itemId/trends" component={ListingTrends} title={I18n.getString('titles::trends')}/>
            <Route path="/item/:itemId/lightTrends" component={LightTrends} title={I18n.getString('titles::trends')}/>
            <Route path="/manage-call" title={I18n.getString('titles::manageCall')} component={ManageCallMain}/>
            <Route path="/manage-call/call-canceled" title={I18n.getString('titles::manageCall')} component={() => <ManageCallMain canceled={true} />}/>
            <Route path="*" status="404" component={NoMatch} title={I18n.getString('titles::404')} />
    </Route>
);
